/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.build-selector-header-section {
  width: 50%;
  max-width: 50%;

  display: flex;
  flex-direction: row;
  align-items: center;

  height: var(--page-header-height);
  padding: 0 var(--base-spacing);
  cursor: pointer;

  border-bottom: 2px solid transparent;
}

.build-selector-header-section--compare {
  color: var(--compare-color);

  border-left: 1px solid var(--base-border-color);
}

.build-selector-header-section:hover {
  background: var(--neutral-secondary-highlight-color);
}

.build-selector-header-section--compare:hover {
  background: var(--compare-secondary-highlight-color);
}

.build-selector-header-section__hash {
  font-family: var(--monospace-font-family);
  font-size: var(--monospace-font-size);
  margin-left: calc(var(--pill-spacing) / 2);
}

.build-selector-header-section__message {
  flex-grow: 1;
  margin-right: var(--pill-spacing);

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.build-selector-header-section__variant-label {
  text-transform: uppercase;
  font-weight: var(--medium-font-weight);
  padding-right: var(--pill-spacing);
}

.build-selector-header-section__lhr-link {
  display: none;
}

.build-selector-header-section:hover .build-selector-header-section__lhr-link {
  display: block;
}

.build-selector-header-section--dim {
  opacity: 0.5;
}

.build-selector-header-section--open {
  border-bottom-color: var(--neutral-color);
}

.build-selector-header-section--compare.build-selector-header-section--open {
  border-bottom-color: var(--compare-color);
}
